import {gql} from "@apollo/client";

export const QUERY_GET_USER_PROFILE_GQL = gql`
query GetUserProfile {
    userProfile {
      id
      screenName
      customerId
      customerName
      userId
      paymentStatus
      paymentStatusDenied
      accountId
      isFirst
      employeeId
      adminAccount
      email
      fullName
      exp
    }
  }
`;